// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ButtonIcon } from "@insite/mobius/Button";
import { getProp } from "@insite/mobius/utilities";
import { floatingTooltipStyles } from "@stoneage/App/Components/FloatingTooltip/FloatingTooltip";
import { fontConfig } from "@stoneage/XDL/constants";
import { color, getSystemColor } from "@stoneage/XDL/Utilities";
import { css } from "styled-components";

floatingTooltipStyles.tooltipContent = {
    css: css`
        min-width: 200px;
        max-width: 260px;
        background-color: ${color("common.white")};
        z-index: ${getProp("theme.zIndex.tooltip")};
        font-size: ${fontConfig.xSmall.size}px;
        font-weight: ${fontConfig.weight.regular};
        line-height: ${fontConfig.xSmall.lineHeight};
        border-top: 0;
        padding: 12px;
        box-shadow:
            0 0 0 1px ${color("common.ui5")},
            0 2px 4px 0 ${color("common.black", 0.1)};
    `,
};

floatingTooltipStyles.tooltipArrow = {
    height: 16,
    width: 30,
    fill: getSystemColor("common.white"),
    stroke: `${getSystemColor("common.ui5")}`,
    strokeWidth: 1,
};

floatingTooltipStyles.drawerContent = {
    css: css`
        background-color: ${color("common.white")};
        display: flex;
        position: fixed;
        flex-direction: column;
        right: -400px;
        top: 0;
        height: 100vh;
        padding: 16px;
        width: 332px;
        z-index: ${getProp("theme.zIndex.drawer")};

        ${({ isMounted }: any) =>
            isMounted &&
            css`
                right: 2px;
            `}
    `,
};

floatingTooltipStyles.drawerClose = {
    variant: "link" as any,
    css: css`
        margin: 0 0 8px auto;
        ${ButtonIcon} {
            color: ${color("common.ui7")};
        }
    `,
};
